<app-card title="Confirmation" *ngIf="message" titleColor="success">
    <ion-label color="success">{{message}}</ion-label>
</app-card>
